import { z } from 'zod';

import { emailString, requiredString } from '@/shared/utils/validation';

export const loginInputSchema = z.object({
  username: emailString(),
  password: requiredString(),
});

export const loginWithSsoInputSchema = z.object({
  email: emailString(),
});
